var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-message-header-layout",
      attrs: { "data-test": "date-area" },
    },
    [
      _c(
        "div",
        {
          staticClass: "boss-layout-block boss-message-when",
          attrs: { "data-test": "date" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm._f("formatDate")(_vm.date)) + "\n    "),
          _vm.isRead != null
            ? [
                _vm.isRead
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "boss-message-status-label boss-message-status-label-read",
                        attrs: { "data-test": "read" },
                      },
                      [_vm._v("既読")]
                    )
                  : _c(
                      "span",
                      {
                        staticClass: "boss-message-status-label",
                        attrs: { "data-test": "no-read" },
                      },
                      [_vm._v("未読")]
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }